import { theme as defaultTheme } from '../styles/theme';
import { css } from '../customEmotion';

export const StepperContainer = css`
  display: flex;
  align-items: center;
`;

export const ConnectorContainer = css`
  display: flex;
  align-items: center;
  margin: 0 8px;
  color: ${defaultTheme.color.text.B3};
  font-size: 14px;
`;
